import { useCallback, useState } from 'react';

import { ApiError } from '../lib/api-client';
import { useApiClient } from '../providers/auth-provider';

type ToolResponseStatus = 'idle' | 'loading' | 'success' | 'error';

export function useToolResponse() {
  const apiClient = useApiClient();
  const [status, setStatus] = useState<ToolResponseStatus>('idle');
  const [error, setError] = useState<string | null>(null);

  const submit = useCallback(async (toolCallId: string, payload: Record<string, unknown>) => {
    setStatus('success');
    setError(null);

    try {
      await apiClient.submitToolResponse({ tool_call_id: toolCallId, payload });
    } catch (err) {
      const message = err instanceof ApiError ? err.detail : err instanceof Error ? err.message : 'Unknown error';
      setError(message);
      setStatus('error');
    }
  }, [apiClient]);

  return { submit, status, error };
}
